import { useState, useEffect } from "react";
import useProcessingJobs from "./useProcessingJobs";
import useRecruiterDetails from "@lib/user/useRecruiterDetails";
import { initialJob } from "./useJobStatus";

function updateFromEvent(jobs, job) {
  const eventJob = jobs.find((j) => j.id === job.id) ?? {
    ...initialJob,
    id: job.id,
  };

  // if matching an existing job then update with details from the server event
  eventJob.status = job.status;
  eventJob.metadata = job.metadata;

  const remaining = jobs.filter((j) => j.id !== eventJob.id);

  return [...remaining, eventJob];
}

export default function useUpdateJobStatuses() {
  const { recruiter, isLoading } = useRecruiterDetails();
  const { jobs: jobsResponse, getJobs } = useProcessingJobs();
  const [jobs, setJobs] = useState([]);

  const echo = typeof window === "undefined" ? null : window.Echo;

  useEffect(() => {
    if (!isLoading && recruiter) {
      // initial load of active jobs
      getJobs();

      // setup listener for pusher events only if Echo is available
      if (typeof window !== "undefined" && typeof window.Echo !== "undefined") {
        window.Echo.private(`app.user.${recruiter?.user?.id || ""}`).listen(
          "ProcessingJobStatusChanged",
          (e) => {
            setJobs((jobs) => updateFromEvent(jobs, e.job));
          }
        );
      }
    }
  }, [isLoading, echo]);

  // Reset local jobs to the freshly fetched list whenever it changes. Done
  // during render (React's replacement for a set-state-in-effect); keyed on a
  // stable hash so it only fires when the fetched data actually changes. The
  // Echo listener above then layers live updates on top of this baseline.
  const [prevResponseHash, setPrevResponseHash] = useState(null);
  const responseHash = JSON.stringify(jobsResponse);
  if (responseHash !== prevResponseHash) {
    setPrevResponseHash(responseHash);
    setJobs(jobsResponse);
  }

  return { jobs };
}
